<template>
  <ion-grid>
    <ion-row>
      <ion-col size="12" size-md="8">
        <ion-chip :color="answer.completed ? 'success':'secondary'">
          <ion-label>{{ quizItem.order }}</ion-label>
          <ion-icon v-if="answer.completed" :icon="checkmarkCircleOutline"></ion-icon>
        </ion-chip>
        <span style="font-size:medium">{{ quizItem.title }}</span>
        <ion-icon v-if="quizItem.detail || quizItem.tip" v-on:click="showToast()" style="padding-left: 3px"
                  :icon="informationCircleOutline"></ion-icon>
      </ion-col>
      <ion-col>
          <ion-select placeholder="Select" interface="action-sheet"
                      v-bind:class="{'completed-quiz': answer.code}"
                      v-bind:value="answer.code"
                      v-on:ionChange="selectOption($event)">
            <ion-select-option v-for=" o in options" v-bind:value="o.code" v-bind:key="o.code">{{ o.name }}</ion-select-option>
          </ion-select>
      </ion-col>
    </ion-row>
    <ion-row v-if="answer.code !== 'none' ">
        <ion-row >
          <ion-col size="6" size-md="3" v-for="su of answer.grades.subjects" v-bind:key="su.code">
            <ion-item lines="none">
            <ion-label position="stacked">{{su.name || su.code}}</ion-label>
            <ion-input placeholder="Score" type="number" class="default-input"
                       v-model="su.grade"
                       v-bind:class="{'completed-quiz': su.grade}"
                       @ionChange="dataChanged()"
                       style="margin-top: 4px">
            </ion-input>
            </ion-item>
          </ion-col>

        </ion-row>
    </ion-row>
  </ion-grid>
</template>

<script>
import {
  IonGrid,
  IonRow,
  IonCol,
  IonChip,
  IonIcon,
  IonInput,
  // IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
} from '@ionic/vue';
import {
  checkmarkCircleOutline,
  informationCircleOutline
} from 'ionicons/icons';

import QuizItemSelect from "@/enrol/QuizItemSelect";

export default {
  name: 'QuizItemEnglishCertification',
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonChip,
    IonInput,
    IonIcon,
    // IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption
  },
  mixins: [QuizItemSelect],
  data() {
    return {
      checkmarkCircleOutline,
      informationCircleOutline,
      answer: {
        completed: false,
        option: null,
        grades: {}
      },
      options: [],
      categories: []
    };
  },
  mounted() {
    if (this.quizItem._answer) {
      this.answer = this.quizItem._answer;
    }

    this.initPreviousAnswer();
  },
  props: {
    quizItem: {
      type: Object,
      required: false
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    withPreference: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    initPreviousAnswer() {
      if (this.answer) {
        let ans = (this.options || []).find(o => o.code === this.answer.code);

        if ( ans && ans.grades){
          ans.grades.subjects.forEach( g => {
            let ansg = (this.answer.grades.subjects || []).find(o => o.code === g.code);
            if ( ansg ){
              g.grade = ansg.grade;
            }
          });

          this.answer = ans;
        }
      }
    },
    selectOption(event) {
      this.answer.code = event.detail.value;
      if ( this.answer.code && this.answer.code !== 'none'){
        this.categories = this.quizItem.options.find( o => o.code === this.answer.code).categories;
        this.answer.grades.subjects = [];
        (this.categories || []).forEach( c => {
          this.answer.grades.subjects.push( {code: c.code, name: c.name, grade: 0})
        });
      } else {
        this.answer.grades.subjects = [];
      }

      this.dataChanged();
    },
    dataChanged() {
      if ( this.answer.code ){
        let found = true;
        (this.answer.grades.subjects || []).forEach( su => {
          found = found && su.grade > 0;
        });

        this.answer.completed = found;
      }
      this.$emit('answer', this.answer);
    },
  }
}
</script>
<style>

.default-input {
  color: var(--ion-color-secondary);
  border: thin solid var(--ion-color-secondary);
  border-radius: 10px;
  padding-left: 1em !important;
  min-width: 100%;
}

.completed-quiz {
  color: var(--ion-color-success);
  border: thin solid var(--ion-color-success);
  border-radius: 10px;
  padding-left: 1em !important;
}
</style>
